// Lo que la tabla pinta EN LUGAR de filas cuando no hay de dónde leerlas: cargando la primera
// página, la lectura falló o falta el contexto. Una tabla vacía diría «no hay registros».
import type { ReactNode } from 'react';
import { TableProperties } from 'lucide-react';

export interface UnavailableStateProps {
    title: string;
    body: string;
    /** Sustituye el ícono de tabla por defecto. */
    icon?: ReactNode;
    /** Lo que el operador puede hacer, como «Reintentar». */
    action?: ReactNode;
}

export function UnavailableState({ title, body, icon, action }: UnavailableStateProps) {
    return (
        <div
            role="status"
            className="flex flex-1 flex-col items-center justify-center px-6 py-10 text-center"
        >
            {icon ?? (
                <TableProperties className="mb-3 size-9 text-muted-foreground/40" aria-hidden />
            )}
            <p className="text-[13px] font-semibold">{title}</p>
            <p className="mx-auto mt-1.5 max-w-[54ch] text-[11.5px] leading-relaxed text-muted-foreground">
                {body}
            </p>
            {action === undefined ? null : <div className="mt-4">{action}</div>}
        </div>
    );
}
